import React from 'react';
import { Box, Typography, Link, Container, Paper } from '@mui/material';
import { useLanguage } from './data/languages';

const TermsOfService = () => { // 服务条款页面组件
  const currentLang = useLanguage();
  const config = {
    en: {
      title: "Terms of Service",
      description: "Please review our terms of service to understand the rules and guidelines for using our application.",
      linkText: "View our full Terms of Service",
      linkUrl: "https://gintarot.com"
    },
    zh: {
      title: "服务条款",
      description: "请查看我们的服务条款，了解使用我们应用程序的规则和准则。",
      linkText: "查看完整服务条款",
      linkUrl: "https://gintarot.com"
    }
  };

  const currentConfig = config[currentLang] || config.en;

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          {currentConfig.title}
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="body1" paragraph>
            {currentConfig.description}
          </Typography>

          <Box sx={{ textAlign: 'center', mt: 4 }}>
            <Link
              href={currentConfig.linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              variant="h6"
              sx={{
                color: 'primary.main',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              {currentConfig.linkText}
            </Link>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default TermsOfService;
